'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const menuItemGroupProps = {
  title: String
};

exports.menuItemGroupProps = menuItemGroupProps;
//# sourceMappingURL=menu-item-group.js.map
